import { useMutation, useQueryClient } from "react-query";
import { useCurrentUser, useToastProvider } from "@qualio/ui-components";
import { useCurrentProduct } from "../useCurrentProduct";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { designControlsApi } from "../../api/designControls";
import { ChangeControlElement } from "../../types/router";

export const useRevertToDraft = () => {
  const { t } = useTranslation();
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();
  const { changeControlId: reviewId } =
    useParams<ChangeControlElement>() as ChangeControlElement;
  const queryClient = useQueryClient();
  const { showToast } = useToastProvider();

  return useMutation({
    mutationFn: () =>
      designControlsApi.revertToDraft(companyId, productId, reviewId),
    onSuccess: async () => {
      await queryClient.invalidateQueries([
        "REVIEW",
        companyId,
        productId,
        reviewId,
      ]);
      showToast({
        title: t("reviews.notifications.revertToDraftSuccess.title"),
        description: t(
          "reviews.notifications.revertToDraftSuccess.description",
        ),
        status: "success",
      });
    },
    onError: () => {
      showToast({
        title: t("reviews.notifications.revertToDraftError.title"),
        description: t("reviews.notifications.revertToDraftError.description"),
        status: "error",
      });
    },
  });
};
